import { ZodType, z } from 'zod';

import { FraudDecisionType } from '@/services/serverless/ServerFraudService/schemas';
import { LineItemType } from '../Cart/LineItem';
import { MoneySchema } from '../Money/schemas';

import {
  IOrderID,
  OrderIDType,
  type IBrowserData,
  type IFraudResponse,
  type IGiftCardPayment,
  type IOrderLine
} from '.';
import { LineItemPromotionSchema } from '../Cart/Promotion/schemas';

/** Zod schema for {@link IOrderLine}. */
export const OrderLineSchema = z.object({
  uuid: z.string(),
  lineNumber: z.number(),
  sku: z.string(),
  upc: z.string(),
  quantity: z.number(),
  name: z.string(),
  netTotal: MoneySchema,
  total: MoneySchema,
  unitPrice: MoneySchema,
  subtotal: MoneySchema,
  tax: MoneySchema,
  taxRate: z.number(),
  type: z.nativeEnum(LineItemType),
  estimatedDeliveryDate: z.string().nullish(),
  promotions: z.array(LineItemPromotionSchema),
  isReturnable: z.boolean().optional()
}) satisfies ZodType<IOrderLine>;

export const BrowserDataSchema = z.object({
  shopperDevice: z.union([z.literal('desktop'), z.literal('mobile')]),
  userAgent: z.string()
}) satisfies ZodType<IBrowserData>;

export const GiftCardPaymentSchema = z.object({
  paymentReference: z.string(),
  paymentType: z.literal('giftCard'),
  amount: z.number(),
  csc: z.string()
}) satisfies ZodType<IGiftCardPayment>;

export const FraudResponseSchema = z.object({
  type: z.nativeEnum(FraudDecisionType),
  code: z.string()
}) satisfies ZodType<IFraudResponse>;

export const OrderIDSchema = z.object({
  value: z.string(),
  displayValue: z.string(),
  type: z.nativeEnum(OrderIDType)
}) satisfies ZodType<IOrderID>;
